import {createAction, props} from '@ngrx/store';
import {NameResponse} from '../../../../services/chat/model/nameResponse';
import {BrokerUserProfile} from '../../../../services/broker/model/brokerUserProfile';
import {BrokerUserOwnProfileModel} from '../../../../services/broker/model/brokerUserOwnProfileModel';

export const HttpErrorDetected = createAction(
    '[Core] Http Error Detected',
    props<{ key: string, data?: NameResponse }>()
);

export const SetPageTitle = createAction(
    '[Core] Set Page Title',
    props<{ payload: string }>()
);

export const SetTabId = createAction(
    '[Core] Set Tab Id',
    props<{ tabId: string }>()
);

export const SetCurrentId = createAction(
    '[Core] Set Cabinet Id',
    props<{ id: string }>()
);


export const SetTokenSuccess = createAction(
    '[User] Set Token Success',
    props<{ payload: { accessToken: string, deviceId: string } }>()
);

export const LoadUserProfileSuccess = createAction(
    '[User] Load User Profile Success',
    props<{ payload: BrokerUserProfile }>()
);

export const LogOutSuccess = createAction(
    '[User] Log Out Success',
);


export const EditProfile = createAction(
    '[Login] Edit Profile',
    props<{ payload: BrokerUserOwnProfileModel }>()
);

